
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-ps/penilaian",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-ps/penilaian/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-ps/penilaian"])
      });
    }
  